const SpecialOffer = ({
  description = '',
  endDateYyyyMmDd = '',
  offerIdEncoded = '',
  startDateYyyyMmDd = '',
} = {}) => ({
  description: String(description),
  endDateYyyyMmDd: String(endDateYyyyMmDd),
  offerIdEncoded: String(offerIdEncoded),
  startDateYyyyMmDd: String(startDateYyyyMmDd),
});

export default SpecialOffer;

export type SpecialOfferProps = Partial<ReturnType<typeof SpecialOffer>>;
